/**
 * @export
 * @class WarningBanner
 * 경고배너 영역
 */
export default class WarningBanner {
  constructor(roles) {
    this._pivotElement = document.getElementsByClassName('separate')[0];
    this.preRender(roles);
    this.render();
  }

  preRender(roles) {
    const result = roles.map(
      ([keys, target]) =>
        !![...keys].filter(key => [...target].includes(key)).length
    );

    this._result = result;
    this._hasJob = result.includes(true);
  }

  render() {
    if (!this._pivotElement || !this._hasJob) return;

    const documentFragment = document.createDocumentFragment();
    const wrap = document.createElement('div');
    wrap.className = 'warning_banner';

    [...this.bannerList].forEach((staticHtml, index) => {
      if (this._result[index]) wrap.innerHTML += staticHtml;
    });
    documentFragment.appendChild(wrap);

    this._pivotElement.insertBefore(
      documentFragment,
      this._pivotElement.firstChild
    );
  }

  get bannerList() {
    return [
      `<h3 class="warning_banner_title">
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                    <circle stroke="#D00" fill="#FFF" cx="9" cy="9" r="8.5"></circle>
                    <g fill="#16181A" fill-rule="nonzero">
                    <path d="M7.408 13H5.856V7.017l-1.853.574V6.33L7.24 5.17h.167zM12.663 9.874c-.405.397-.878.596-1.418.596-.691 0-1.245-.237-1.66-.711-.415-.475-.623-1.115-.623-1.92 0-.513.112-.983.336-1.41.223-.428.536-.761.937-1a2.6 2.6 0 0 1 1.353-.357c.516 0 .974.13 1.375.387.401.258.713.628.935 1.112.222.483.335 1.036.338 1.66v.574c0 1.304-.324 2.328-.972 3.072-.648.745-1.566 1.143-2.755 1.193l-.382.005v-1.294l.344-.006c1.35-.06 2.08-.694 2.192-1.901zm-1.037-.59c.25 0 .466-.065.647-.194.181-.13.318-.285.411-.467v-.64c0-.526-.1-.934-.3-1.224-.201-.29-.47-.435-.806-.435-.312 0-.568.142-.768.427-.201.284-.301.642-.301 1.071 0 .426.097.776.293 1.05.195.274.47.411.824.411z"></path>
                    </g>
                </g>
            </svg>
            <span class="warning_banner_title_text">주류판매 안내</span>
        </h3>
        <p class="warning_banner_contents">
              경고 : 지나친 음주는 암 발생의 원인이 됩니다. <br>
              청소년 음주는 성장과 뇌 발달을 저해하며, <br>
              임신 중 음주는 태아의 기형 발생이나 유산의 위험을 높입니다.
        </p>`,
    ];
  }
}
